export const getImagesAlt = (text: string, idx: number, numberImages: number) =>
  `${text}${numberImages > 1 ? ` ${idx + 1}` : ''}`;
